import React, { useState, useEffect, useCallback, useRef } from 'react';

import imgMimarlik from '../projectitems/Hizmetler/icmimarlik.png';
import imgDekorasyon from '../projectitems/Hizmetler/icmekandekarasyon.png';
import imgMakine from '../projectitems/Hizmetler/ismakinelerikiralama.png';
import imgSap from '../projectitems/Hizmetler/sapveselfleveling.png';
import imgKaro from '../projectitems/Hizmetler/karohalıvepvc.png';
import imgKarot from '../projectitems/Hizmetler/karotray.png';
import imgInsaat from '../projectitems/Hizmetler/insaatmalzemeleritemini.png';

const products = [
    {
        id: 1,
        image: imgMimarlik,
        title: 'Mimarlık ve İç Mimarlık Hizmetleri',
        items: [
            'Mimari proje tasarımı ve uygulama',
            'İç mimari tasarım ve dekorasyon',
            'Konsept geliştirme',
            '3D görselleştirme',
            'Uygulama ve şantiye takibi',
        ],
    },
    {
        id: 2,
        image: imgDekorasyon,
        title: 'İç Mekân Dekorasyon ve Uygulama',
        items: [
            'Anahtar teslim dekorasyon projeleri',
            'Ofis, konut ve ticari alan tasarımı',
            'Tadilat ve renovasyon hizmetleri',
        ],
    },
    {
        id: 3,
        image: imgMakine,
        title: 'İş Makineleri Kiralama',
        items: [
            'Operatörlü ve operatörsüz iş makinesi kiralama',
            'Kısa ve uzun dönem kiralama seçenekleri',
        ],
    },
    {
        id: 4,
        image: imgSap,
        title: 'Şap ve Self Leveling Uygulamaları',
        items: [
            'Beton şap uygulamaları',
            'Self leveling (kendiliğinden yayılan şap) uygulamaları',
            'Zemin düzeltme ve tesviye işlemleri',
        ],
    },
    {
        id: 5,
        image: imgKaro,
        title: 'Karo Halı ve PVC Zemin Kaplama',
        items: [
            'Karo halı uygulamaları',
            'PVC zemin kaplama uygulamaları',
            'Ticari ve endüstriyel zemin çözümleri',
        ],
    },
    {
        id: 6,
        image: imgKarot,
        title: 'Karot ve Raylı Kesim Uygulamaları',
        items: [
            'Beton delme (karot) hizmetleri',
            'Beton kesme ve raylı kesim uygulamaları',
            'Güçlendirme ve tadilat amaçlı kesim işlemleri',
        ],
    },
    {
        id: 7,
        image: imgInsaat,
        title: 'İnşaat Malzemeleri Temini',
        items: [
            'İnşaat malzemeleri satışı',
            'Projeye özel malzeme tedariki',
            'Toptan ve perakende satış',
        ],
    },
];

const total = products.length;

const getOffset = (index, active) => {
    let diff = index - active;
    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;
    return diff;
};

const SWIPE_THRESHOLD = 50;

const Products = () => {
    const [active, setActive] = useState(0);
    const touchStartX = useRef(0);

    const next = useCallback(() => {
        setActive((prev) => (prev + 1) % total);
    }, []);

    const prev = useCallback(() => {
        setActive((prev) => (prev - 1 + total) % total);
    }, []);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        const deltaX = e.changedTouches[0].clientX - touchStartX.current;
        if (deltaX < -SWIPE_THRESHOLD) next();
        else if (deltaX > SWIPE_THRESHOLD) prev();
    };

    useEffect(() => {
        const timer = setInterval(next, 2000);
        return () => clearInterval(timer);
    }, [next]);

    return (
        <section className="products" id="magaza">
            <div className="products__container">
                <div className="products__header">
                    <p className="section-eyebrow">Neler Yapıyoruz</p>
                    <h2 className="section-title">HİZMETLERİMİZ</h2>
                    <p className="products__desc">
                        Her mekan için özel tasarlanmış, profesyonel mimarlık hizmetlerimizi keşfedin.
                    </p>
                </div>

                <div className="products__carousel">
                    <button className="products__arrow products__arrow--prev" onClick={prev} aria-label="Önceki">
                        ‹
                    </button>

                    <div
                        className="products__track"
                        onTouchStart={handleTouchStart}
                        onTouchEnd={handleTouchEnd}
                    >
                        {products.map((p, i) => {
                            const offset = getOffset(i, active);
                            const isVisible = Math.abs(offset) <= 2;
                            const isCenter = offset === 0;
                            const opacity = isCenter ? 1 : Math.abs(offset) === 1 ? 0.4 : 0.15;

                            return (
                                <div
                                    className="products__slide"
                                    key={p.id}
                                    style={{
                                        transform: `translateX(${offset * 370}px)`,
                                        opacity: isVisible ? opacity : 0,
                                        filter: isCenter ? 'none' : `blur(${Math.abs(offset)}px)`,
                                        zIndex: 10 - Math.abs(offset),
                                        pointerEvents: isVisible ? 'auto' : 'none',
                                    }}
                                    onClick={() => !isCenter && setActive(i)}
                                >
                                    <div className="product-card">
                                        <div className="product-card__visual">
                                            <img src={p.image} alt={p.title} className="product-card__img" />
                                        </div>
                                        <div className="product-card__info">
                                            <h3 className="product-card__title">{p.title}</h3>
                                            <ul className="product-card__list">
                                                {p.items.map((item, idx) => (
                                                    <li key={idx}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <button className="products__arrow products__arrow--next" onClick={next} aria-label="Sonraki">
                        ›
                    </button>
                </div>

                <div className="products__dots">
                    {products.map((_, i) => (
                        <button
                            key={i}
                            className={`products__dot${i === active ? ' products__dot--active' : ''}`}
                            onClick={() => setActive(i)}
                            aria-label={`Hizmet ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Products;
